module.exports = {
  Form: require('./lib/forms/Form').default,

  Input: require('./lib/forms/Input').default,

  TextArea: require('./lib/forms/Textarea').default,

  Checkbox: require('./lib/forms/Checkbox').default,

  Radio: require('./lib/forms/Radio').default,

  Select: require('./lib/forms/Select').default,

  FormGroup: require('./lib/forms/FormGroup').default,

  Label: require('./lib/forms/Label').default,

  Slider: require('./lib/forms/Slider').default,
  Handle: require('./lib/forms/Slider').Handle,

  CountBox: require('./lib/forms/CountBox').default,

  InputGroup: require('./lib/forms/InputGroup').default,

  ErrorLabel: require('./lib/forms/ErrorLabel').default,

  withForms: require('./lib/forms/with-forms').default,
};
